var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animate-pulse mb-4 w-48 h-2.5",attrs:{"role":"status"}},[_c('div',{staticClass:"h-full w-full bg-gray-disabled-variant rounded-full"}),_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }